import { render, staticRenderFns } from "./vue-flow-edit-menu-group.vue?vue&type=template&id=5a7e39fc&"
import script from "./vue-flow-edit-menu-group.vue?vue&type=script&lang=js&"
export * from "./vue-flow-edit-menu-group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/mychefkoo/Documents/cloud-dom/cloud-web/erp-flexible-web21/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a7e39fc')) {
      api.createRecord('5a7e39fc', component.options)
    } else {
      api.reload('5a7e39fc', component.options)
    }
    module.hot.accept("./vue-flow-edit-menu-group.vue?vue&type=template&id=5a7e39fc&", function () {
      api.rerender('5a7e39fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/g6-canvas/editor/vue-flow-edit-menu-group.vue"
export default component.exports